<div (fileDropped)="onFilesDropped($event)"
     [accept]="accept()"
     [class.compact]="compact()"
     [class.disabled]="loadingState() !== 'none' || disabled()"
     [multiple]="multiple()"
     class="work-ui-dropzone-multi"
     workUiDnd>
  <input (change)="fileBrowseHandler($event)"
         [accept]="accept().join(',')"
         [multiple]="multiple()"
         id="fileDropRef"
         type="file" />
  <div [class.fade-out-opacity-only]="loadingState() !== 'none'"
       class="work-ui-dropzone-multi__content">
    <work-ui-icon [fontSize]="compact() ? 24 : 48"
                  [name]="'upload_file'" />
    @if (disabled()) {
      @if (disabledReason()) {
        <p>{{ disabledReason() | translate }}</p>
      }
    } @else {
      @if (multiple()) {
        <p>{{ 'DATEIEN_HIERHIN_ZIEHEN' | translate }}</p>
      }
      @if (!multiple()) {
        <p>{{ 'DATEI_HIERHIN_ZIEHEN' | translate }}</p>
      }
    }
  </div>
  @if (loadingState() !== 'none') {
    <work-ui-loading-spinner
      [iconSize]="40"
      [loadingState]="loadingState()" />
  }
</div>
